export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите этаж ', trigger: 'blur' },
    ],
    corps_id: [
        { required: true, message: 'Пожалуйста, введите корпус ', trigger: 'blur' },
    ],
};
